import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Reels from "@/components/Reels";
import Manifesto from "@/components/Manifesto";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import Stories from "@/components/Stories";
import Location from "@/components/Location";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import FloatingBook from "@/components/FloatingBook";
import ReelsAdmin from "@/pages/ReelsAdmin";
import HeroPreview from "@/pages/HeroPreview";
import CarePage from "@/pages/CarePage";
import AuthCallback from "@/components/AuthCallback";
import { Analytics } from "@/components/Analytics";

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    // Only reset when a landing/other route mounts — home has its own hash logic.
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.hash]);
  return null;
};

const Home = () => {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const scrollTo = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const t1 = setTimeout(scrollTo, 120);
    const t2 = setTimeout(scrollTo, 900);
    window.addEventListener("load", scrollTo, { once: true });
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("load", scrollTo);
    };
  }, [location.hash, location.pathname]);

  return (
    <div className="App min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <About />
        <Reels />
        <Manifesto />
        <EditorialMarquee />
        <Services />
        <Stories />
        <Location />
        <Booking />
      </main>
      <Footer />
      <FloatingBook />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/reels" element={<ReelsAdmin />} />
      <Route path="/preview/hero" element={<HeroPreview />} />
      <Route path="/care/:slug" element={<CarePage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
